/** "1 size", "3 sizes": a count with an English word that takes a plain "s" in the plural. */
export const plural = (count: number, word: string) =>
  `${count} ${word}${count === 1 ? '' : 's'}`;
